import { colors } from '@hummingbird/shared';

const contentLoaderConfig = {
  backgroundColor: colors.sand,
  foregroundColor: colors.concrete,
  speed: 1,
};

export default contentLoaderConfig;
